// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"f0-z","sponsoredTooltipWrapper":"g0-z","sponsoredTooltip":"h0-z","newCard":"i0-z"};